import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Versions} from "../../environments/versions";

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  versions = Versions
  constructor() { }

  ngOnInit() {
    console.log('SHA'+' = ' +this.versions.revision);
    console.log('Branch'+' = ' +this.versions.branch);
  }

}
